import React, { useState } from 'react'
import Button from '../Button'
import { getCookie } from '../../utilities/helpers'
import { useSelector } from 'react-redux';
import { selectFilterData } from '../../features/mainFilter/selectors';
import { selectSecondaryFilter } from '../../features/secondaryFilter/secondaryFilterSlice';
import { prepareSearchRequest } from '../../features/dealsList/dealsListSlice';
import { FETCH_OFFERS } from '../../constants';
import makeRequest from '../../api/makeRequest';

const CardsPositionDebug = () => {
  const mainFilter = useSelector(selectFilterData);
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const searchProfile = useSelector((state) => state.user.searchProfile);
  const [dealOftheDayLoading, setDealOfTheDayLoading] = useState(false);

  const handleDebugCardsClick = () => {
    const search = prepareSearchRequest({
      mainFilter: mainFilter.searchEngine,
      secondaryFilter: secondaryFilter.data
    });
    const userData = JSON.parse(localStorage.getItem('hf_user'));

    window.open(`${FETCH_OFFERS}?data=${JSON.stringify(search)}&showCardsPositionDebug=true&muid=${userData?.user?.muid}&searchUserProfile=${searchProfile?.id}`);
  }

  const handleDebugDealOfTheDay = () => {
    setDealOfTheDayLoading(true);
    const search = prepareSearchRequest({
      mainFilter: mainFilter.searchEngine,
      secondaryFilter: secondaryFilter.data
    });
    search.dealOfTheDay = true;
    makeRequest({
      method: 'GET',
      url: `${FETCH_OFFERS}?data=${JSON.stringify(search)}`,
    }).then((response) => {
        setDealOfTheDayLoading(false);
        if (!response.data.success) throw new Error('Data fetch error');
        if (response.data.data && response.data.data?.offers?.length) {
          const dealOfTheDayUrl = response.data.data.offers[0] && response.data.data.offers[0].offer && response.data.data.offers[0].offer.packageDeeplinkUrl;
          if (dealOfTheDayUrl) {
            window.open(dealOfTheDayUrl);
          }
        }
      });
  };

  return (
    <>
      {getCookie('hfdebug') ? (
        <div className="debug-btns-panel flex gap-2">
          <Button
            type="ghost"
            size="small"
            label="show cards position"
            className="mt-3"
            onClick={handleDebugCardsClick}
          />

          <Button
            type="ghost"
            size="small"
            label="deal of the day"
            className="mt-3"
            onClick={handleDebugDealOfTheDay}
            disabled={dealOftheDayLoading}
          />
        </div>
      ) : null}
    </>
  )
}

export default CardsPositionDebug
